export const HomeIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75 9.9375V21C3.75 21.1989 3.82902 21.3897 3.96967 21.5303C4.11032 21.671 4.30109 21.75 4.5 21.75H9V15.375C9 15.0766 9.11853 14.7905 9.3295 14.5795C9.54048 14.3685 9.82663 14.25 10.125 14.25H13.875C14.1734 14.25 14.4595 14.3685 14.6705 14.5795C14.8815 14.7905 15 15.0766 15 15.375V21.75H19.5C19.6989 21.75 19.8897 21.671 20.0303 21.5303C20.171 21.3897 20.25 21.1989 20.25 21V9.9375"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.5 11.9999L12.5105 2.43741C12.2761 2.18991 11.7281 2.1871 11.4895 2.43741L1.5 11.9999M18.75 8.39054V2.99991H16.5V6.23429"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AccountIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.5C6.477 2.5 2 6.977 2 12.5C2 18.023 6.477 22.5 12 22.5C17.523 22.5 22 18.023 22 12.5C22 6.977 17.523 2.5 12 2.5Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.271 18.846C4.271 18.846 6.5 16 12 16C17.5 16 19.73 18.846 19.73 18.846M12 12.5C12.7956 12.5 13.5587 12.1839 14.1213 11.6213C14.6839 11.0587 15 10.2956 15 9.5C15 8.70435 14.6839 7.94129 14.1213 7.37868C13.5587 6.81607 12.7956 6.5 12 6.5C11.2043 6.5 10.4413 6.81607 9.87868 7.37868C9.31607 7.94129 9 8.70435 9 9.5C9 10.2956 9.31607 11.0587 9.87868 11.6213C10.4413 12.1839 11.2043 12.5 12 12.5Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ServicesIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5 18.5V17H20.9242C20.8275 16.5305 20.6411 16.0841 20.3752 15.6852L21.4928 14.5677L20.4323 13.5073L19.3148 14.6248C18.9159 14.3589 18.4695 14.1725 18 14.0757V12.5H16.5V14.0757C16.0305 14.1725 15.5841 14.3589 15.1852 14.6248L14.0677 13.5073L13.0073 14.5677L14.1248 15.6852C13.8589 16.0841 13.6725 16.5305 13.5757 17H12V18.5H13.5757C13.6725 18.9695 13.8589 19.4159 14.1248 19.8148L13.0073 20.9323L14.0677 21.9928L15.1852 20.8752C15.5841 21.1411 16.0305 21.3275 16.5 21.4242V23H18V21.4242C18.4695 21.3275 18.9159 21.1411 19.3148 20.8752L20.4323 21.9928L21.4928 20.9323L20.3752 19.8148C20.6411 19.4159 20.8275 18.9695 20.9242 18.5H22.5ZM17.25 20C16.805 20 16.37 19.868 16 19.6208C15.63 19.3736 15.3416 19.0222 15.1713 18.611C15.001 18.1999 14.9564 17.7475 15.0432 17.311C15.13 16.8746 15.3443 16.4737 15.659 16.159C15.9737 15.8443 16.3746 15.63 16.811 15.5432C17.2475 15.4564 17.6999 15.501 18.111 15.6713C18.5222 15.8416 18.8736 16.13 19.1208 16.5C19.368 16.87 19.5 17.305 19.5 17.75C19.4994 18.3466 19.2622 18.9185 18.8403 19.3403C18.4185 19.7622 17.8466 19.9994 17.25 20Z"
      fill={color}
    />
    <path
      d="M10.5 20.5002L8.0745 19.2065C6.99402 18.6318 6.09042 17.7737 5.46069 16.7243C4.83095 15.6749 4.49884 14.4738 4.50001 13.25V3.5H19.5V11H21V3.5C20.9996 3.1023 20.8414 2.721 20.5602 2.43978C20.279 2.15856 19.8977 2.0004 19.5 2H4.50001C4.1023 2.0004 3.721 2.15856 3.43978 2.43978C3.15857 2.721 3.0004 3.1023 3.00001 3.5V13.25C2.99833 14.7458 3.40404 16.2137 4.17359 17.4964C4.94313 18.779 6.04745 19.8278 7.36801 20.5303L10.5 22.2005V20.5002Z"
      fill={color}
    />
  </svg>
);

export const LogoutIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.25 16.25V18.125C14.25 18.6223 14.0525 19.0992 13.7008 19.4508C13.3492 19.8025 12.8723 20 12.375 20H4.875C4.37772 20 3.90081 19.8025 3.54917 19.4508C3.19754 19.0992 3 18.6223 3 18.125V6.875C3 6.37772 3.19754 5.90081 3.54917 5.54917C3.90081 5.19754 4.37772 5 4.875 5H12C13.0355 5 14.25 5.83953 14.25 6.875V8.75M17.25 16.25L21 12.5L17.25 8.75M8.25 12.5H20.25"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SerialNumberIcon = ({ color = 'black' }) => (
  <svg
    width="16"
    height="22"
    viewBox="0 0 16 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.25 7.2425C4.25 7.44141 4.32902 7.63218 4.46967 7.77283C4.61032 7.91348 4.80109 7.9925 5 7.9925H5.9015L5.57 9.5H4.25C4.05109 9.5 3.86032 9.57902 3.71967 9.71967C3.57902 9.86032 3.5 10.0511 3.5 10.25C3.5 10.4489 3.57902 10.6397 3.71967 10.7803C3.86032 10.921 4.05109 11 4.25 11H5.237L5.024 11.957C4.98103 12.1513 5.01703 12.3548 5.12407 12.5226C5.2311 12.6904 5.40041 12.8088 5.59475 12.8517C5.78909 12.8947 5.99253 12.8587 6.16033 12.7517C6.32813 12.6446 6.44654 12.4753 6.4895 12.281L6.773 11H8.2265L8.012 11.9555C7.99053 12.0516 7.9882 12.151 8.00515 12.2481C8.0221 12.3451 8.058 12.4378 8.11079 12.521C8.16358 12.6041 8.23223 12.6761 8.31282 12.7327C8.39341 12.7893 8.48437 12.8295 8.5805 12.851C8.67663 12.8725 8.77604 12.8748 8.87307 12.8578C8.9701 12.8409 9.06283 12.805 9.14599 12.7522C9.22915 12.6994 9.30109 12.6308 9.35771 12.5502C9.41433 12.4696 9.45453 12.3786 9.476 12.2825L9.7625 11H11C11.1989 11 11.3897 10.921 11.5303 10.7803C11.671 10.6397 11.75 10.4489 11.75 10.25C11.75 10.0511 11.671 9.86032 11.5303 9.71967C11.3897 9.57902 11.1989 9.5 11 9.5H10.097L10.4345 7.9925H11.75C11.9489 7.9925 12.1397 7.91348 12.2803 7.77283C12.421 7.63218 12.5 7.44141 12.5 7.2425C12.5 7.04359 12.421 6.85282 12.2803 6.71217C12.1397 6.57152 11.9489 6.4925 11.75 6.4925H10.769L10.9805 5.543C11.002 5.44687 11.0043 5.34746 10.9873 5.25043C10.9704 5.1534 10.9345 5.06066 10.8817 4.97751C10.8289 4.89435 10.7603 4.82241 10.6797 4.76579C10.5991 4.70917 10.5081 4.66897 10.412 4.6475C10.3159 4.62603 10.2165 4.6237 10.1194 4.64065C10.0224 4.6576 9.92966 4.6935 9.84651 4.74629C9.67857 4.8529 9.55986 5.02186 9.5165 5.216L9.2315 6.4925H7.7705L7.9805 5.5415C8.01964 5.3489 7.98161 5.14864 7.8746 4.98379C7.76759 4.81894 7.60015 4.70268 7.4083 4.66003C7.21645 4.61737 7.01552 4.65173 6.84874 4.7557C6.68196 4.85968 6.56266 5.02496 6.5165 5.216L6.2345 6.4925H5C4.80109 6.4925 4.61032 6.57152 4.46967 6.71217C4.32902 6.85282 4.25 7.04359 4.25 7.2425ZM8.561 9.5H7.106L7.439 7.9925H8.897L8.561 9.5ZM3.5 0.5H12.5C13.2956 0.5 14.0587 0.816071 14.6213 1.37868C15.1839 1.94129 15.5 2.70435 15.5 3.5V17.7455C15.5 17.9444 15.421 18.1352 15.2803 18.2758C15.1397 18.4165 14.9489 18.4955 14.75 18.4955H2V18.5C2 18.8978 2.15804 19.2794 2.43934 19.5607C2.72064 19.842 3.10218 20 3.5 20H14.75C14.9489 20 15.1397 20.079 15.2803 20.2197C15.421 20.3603 15.5 20.5511 15.5 20.75C15.5 20.9489 15.421 21.1397 15.2803 21.2803C15.1397 21.421 14.9489 21.5 14.75 21.5H3.5C2.70435 21.5 1.94129 21.1839 1.37868 20.6213C0.81607 20.0587 0.5 19.2956 0.5 18.5V3.5C0.5 2.70435 0.81607 1.94129 1.37868 1.37868C1.94129 0.816071 2.70435 0.5 3.5 0.5ZM2 3.5V16.9955H14V3.5C14 3.10218 13.842 2.72064 13.5607 2.43934C13.2794 2.15804 12.8978 2 12.5 2H3.5C3.10218 2 2.72064 2.15804 2.43934 2.43934C2.15804 2.72064 2 3.10218 2 3.5Z"
      fill={color}
    />
  </svg>
);

export const MacAddressIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 20C3.45 20 2.97933 19.8043 2.588 19.413C2.196 19.021 2 18.55 2 18V14C2.55 14 3.021 13.804 3.413 13.412C3.80433 13.0207 4 12.55 4 12C4 11.45 3.80433 10.979 3.413 10.587C3.021 10.1957 2.55 10 2 10V6C2 5.45 2.196 4.97933 2.588 4.588C2.97933 4.196 3.45 4 4 4H20C20.55 4 21.021 4.196 21.413 4.588C21.8043 4.97933 22 5.45 22 6V10C21.45 10 20.979 10.1957 20.587 10.587C20.1957 10.979 20 11.45 20 12C20 12.55 20.1957 13.0207 20.587 13.412C20.979 13.804 21.45 14 22 14V18C22 18.55 21.8043 19.021 21.413 19.413C21.021 19.8043 20.55 20 20 20H4ZM4 18H20V15.45C19.3833 15.0833 18.896 14.596 18.538 13.988C18.1793 13.3793 18 12.7167 18 12C18 11.2833 18.1793 10.6207 18.538 10.012C18.896 9.404 19.3833 8.91667 20 8.55V6H4V8.55C4.61667 8.91667 5.10433 9.404 5.463 10.012C5.821 10.6207 6 11.2833 6 12C6 12.7167 5.821 13.3793 5.463 13.988C5.10433 14.596 4.61667 15.0833 4 15.45V18ZM12 17C12.2833 17 12.521 16.904 12.713 16.712C12.9043 16.5207 13 16.2833 13 16C13 15.7167 12.9043 15.479 12.713 15.287C12.521 15.0957 12.2833 15 12 15C11.7167 15 11.4793 15.0957 11.288 15.287C11.096 15.479 11 15.7167 11 16C11 16.2833 11.096 16.5207 11.288 16.712C11.4793 16.904 11.7167 17 12 17ZM12 13C12.2833 13 12.521 12.904 12.713 12.712C12.9043 12.5207 13 12.2833 13 12C13 11.7167 12.9043 11.479 12.713 11.287C12.521 11.0957 12.2833 11 12 11C11.7167 11 11.4793 11.0957 11.288 11.287C11.096 11.479 11 11.7167 11 12C11 12.2833 11.096 12.5207 11.288 12.712C11.4793 12.904 11.7167 13 12 13ZM12 9C12.2833 9 12.521 8.904 12.713 8.712C12.9043 8.52067 13 8.28333 13 8C13 7.71667 12.9043 7.479 12.713 7.287C12.521 7.09567 12.2833 7 12 7C11.7167 7 11.4793 7.09567 11.288 7.287C11.096 7.479 11 7.71667 11 8C11 8.28333 11.096 8.52067 11.288 8.712C11.4793 8.904 11.7167 9 12 9Z"
      fill={color}
    />
  </svg>
);

export const DeviceIcon = ({ color = 'black' }) => (
  <svg
    width="52"
    height="34"
    viewBox="0 0 52 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.33334 19.6112C4.33334 19.1509 4.70644 18.7778 5.16668 18.7778H46.8333C47.2936 18.7778 47.6667 19.1509 47.6667 19.6112C47.6667 20.0714 47.2936 20.4445 46.8333 20.4445H5.16667C4.70644 20.4445 4.33334 20.0714 4.33334 19.6112Z"
      fill={color}
    />
    <path
      d="M43 32.1111H9C4.58172 32.1111 1 28.5294 1 24.1111V19.3255C1 18.2312 1.22448 17.1486 1.65956 16.1446L6.13393 5.81914C7.40172 2.89346 10.2858 1 13.4744 1H38.5256C41.7142 1 44.5983 2.89346 45.8661 5.81914L50.3404 16.1446C50.7755 17.1486 51 18.2312 51 19.3255V24.1111C51 28.5294 47.4183 32.1111 43 32.1111Z"
      stroke={color}
      strokeWidth="2"
    />
    <path
      d="M39.8889 22.9444C39.8889 22.4842 40.262 22.1111 40.7222 22.1111H46.8333C47.2936 22.1111 47.6667 22.4842 47.6667 22.9444C47.6667 23.4047 47.2936 23.7778 46.8333 23.7778H40.7222C40.262 23.7778 39.8889 23.4047 39.8889 22.9444Z"
      fill={color}
    />
  </svg>
);

export const BigDeviceIcon = ({ color = 'black' }) => (
  <svg
    width="84"
    height="54"
    viewBox="0 0 84 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.3335 31.7779C7.3335 31.0415 7.93045 30.4446 8.66683 30.4446H75.3335C76.0699 30.4446 76.6668 31.0415 76.6668 31.7779V31.7779C76.6668 32.5143 76.0699 33.1112 75.3335 33.1112H8.66683C7.93045 33.1112 7.3335 32.5143 7.3335 31.7779V31.7779Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.63215 6.02393C11.2169 2.36683 14.822 0 18.8077 0H65.1923C69.178 0 72.7831 2.36682 74.3679 6.02392L83.1756 26.3494C83.7194 27.6044 84 28.9577 84 30.3255V43.7778C84 49.3006 79.5228 53.7778 74 53.7778H10C4.47715 53.7778 0 49.3006 0 43.7778V30.3255C0 28.9577 0.280599 27.6044 0.824444 26.3494L9.63215 6.02393ZM18.8077 4C16.4163 4 14.2532 5.4201 13.3024 7.61436L4.49467 27.9398C4.16836 28.6928 4 29.5048 4 30.3255V43.7778C4 47.0915 6.68629 49.7778 10 49.7778H74C77.3137 49.7778 80 47.0915 80 43.7778V30.3255C80 29.5048 79.8316 28.6928 79.5053 27.9398L70.6976 7.61435C69.7468 5.42009 67.5837 4 65.1923 4H18.8077Z"
      fill={color}
    />
    <path
      d="M64.2217 37.1112C64.2217 36.3748 64.8186 35.7778 65.555 35.7778H75.3328C76.0692 35.7778 76.6661 36.3748 76.6661 37.1112V37.1112C76.6661 37.8475 76.0692 38.4445 75.3328 38.4445H65.555C64.8186 38.4445 64.2217 37.8475 64.2217 37.1112V37.1112Z"
      fill={color}
    />
  </svg>
);
